import React from 'react'
import PropTypes from 'prop-types'
import { GridColumn } from 'semantic-ui-react'
import RegisteredFormField from '../../../common/RegisteredFormField'
import StateSelectFormField from '../inputs/StateSelectFormField'
import GenderSelect from '../inputs/GenderSelect'
import HeightSelectFeet from '../inputs/HeightSelectFeet'
import HeightSelectInches from '../inputs/HeightSelectInches'
import CurrencyInput from '../inputs/CurrencyInput'

const PersonalFields = ({ rootPath, withSalary = false }) => {
  return <>
    <GridColumn computer={3} tablet={8} mobile={16}>
      <RegisteredFormField
        id='dob'
        path={`${rootPath}.birthDate`}
        label='Birth Date'
      />
    </GridColumn>
    <GridColumn computer={5} tablet={8} mobile={16}>
      <StateSelectFormField
        id='birthState'
        path={`${rootPath}.birthState`}
        label='Birth State'
        withNA
      />
    </GridColumn>
    <GridColumn computer={4} tablet={8} mobile={16}>
      <GenderSelect
        rootPath={rootPath}
      />
    </GridColumn>
    <GridColumn computer={4} tablet={8} mobile={16}>
      <RegisteredFormField
        id='ssn'
        path={`${rootPath}.ssnId`}
        label='SSN/ID (optional)'
        viewMask={(v) => `xxx-xx-${v.slice(-4)}`}
      />
    </GridColumn>
    <GridColumn computer={4} tablet={8} mobile={16}>
      <RegisteredFormField
        id='weight'
        path={`${rootPath}.weight`}
        label='Weight (Lbs)'
      />
    </GridColumn>
    <GridColumn computer={3} tablet={8} mobile={16}>
      <HeightSelectFeet path={rootPath} />
    </GridColumn>
    <GridColumn computer={3} tablet={8} mobile={16}>
      <HeightSelectInches path={rootPath} />
    </GridColumn>
    {withSalary && <GridColumn computer={5} tablet={8} mobile={16}>
      <CurrencyInput id='annualSalary' path={`${rootPath}.annualSalary`} label='Annual Salary' />
    </GridColumn>}
  </>
}

PersonalFields.propTypes = {
  /** Redux store object root path */
  rootPath: PropTypes.string.isRequired,
  /** Whether or not to render an Annual Salary input */
  withSalary: PropTypes.bool
}

export default PersonalFields